// lib
import React from 'react';
import PropTypes from 'prop-types';

// components
import CardGroup from './parts/CardGroup';
import Alphabet from './parts/Alphabet';

// PROPSTYPES
const propTypes = {
  lexiqueResults: PropTypes.array.isRequired,
};

//
const groupArray = arr => {
  const map = arr.reduce((acc, val) => {
    const char = val.slug.charAt(0).toUpperCase();
    acc[char] = [].concat((acc[char] || []), val);
    return acc;
  }, {});
  const res = Object.keys(map).map(el => ({
    id: el,
    items: map[el],
  }));
  return res;
};

function LexiqueResults(props) {
  const results = props.lexiqueResults;
  const sortedResults = groupArray(results).sort((a, b) => {
    if (a.id < b.id) { return -1; }
    if (a.id > b.id) { return 1; }
    return 0;
  });
  const activeAlphabets = sortedResults.map(result => result.id);
  return (
    <React.Fragment >
      {sortedResults.length !== 0 &&
      <Alphabet activeAlphabets={activeAlphabets} />}
      <div className="lexiqueResultContainer">
        {sortedResults.map((resultGroup) =>
          <CardGroup
            key={resultGroup.id}
            id={resultGroup.id}
            items={resultGroup.items}
          />)}
      </div>
    </React.Fragment>

  );
}
LexiqueResults.propTypes = propTypes;
export default LexiqueResults;



// WEBPACK FOOTER //
// ./src/app/components/pages/lexique/lexiqueResults/LexiqueResults.js